// client/src/hooks/useAuth.js
import { useNavigate } from 'react-router-dom'
import { useAuth as useAuthContext } from '../context/AuthContext'

function useAuth() {
  const context = useAuthContext()
  const navigate = useNavigate()

  // Wrap the context logout with navigation
  const logout = async () => {
    try {
      await context.logout()
      navigate('/landing')
    } catch (err) {
      console.error('Logout failed:', err)
    }
  }

  return {
    ...context,
    logout,
  }
}

export default useAuth
